import { NgIf, NgTemplateOutlet, NgFor, NgComponentOutlet } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import * as i1 from '@ng-doc/app/classes/root-page';
import { NgDocCodeComponent } from '@ng-doc/app/components/code';
import { NgDocDemoDisplayerComponent } from '@ng-doc/app/components/demo-displayer';
import { NgDocFullscreenButtonComponent } from '@ng-doc/app/components/fullscreen-button';
import { asArray } from '@ng-doc/core/helpers/as-array';
import { NgDocTabGroupComponent, NgDocTabComponent, NgDocIconComponent, NgDocExecutePipe } from '@ng-doc/ui-kit';
function NgDocDemoComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_0_ng_doc_code_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-code", 9);
  }
  if (rf & 2) {
    const asset_r1 = ctx.$implicit;
    i0.ɵɵproperty("html", asset_r1.code);
  }
}
function NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_0_ng_doc_code_1_Template, 1, 1, "ng-doc-code", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.assets);
  }
}
function NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_ng_doc_tab_3_ng_template_1_ng_doc_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 14);
  }
  if (rf & 2) {
    const asset_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("customIcon", asset_r3.icon);
  }
}
function NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_ng_doc_tab_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_ng_doc_tab_3_ng_template_1_ng_doc_icon_0_Template, 1, 1, "ng-doc-icon", 13);
    i0.ɵɵtext(1);
  }
  if (rf & 2) {
    const asset_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", asset_r3.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", asset_r3.title, " ");
  }
}
function NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_ng_doc_tab_3_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-code", 9);
  }
  if (rf & 2) {
    const asset_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("html", asset_r3.code);
  }
}
function NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_ng_doc_tab_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-doc-tab", 12);
    i0.ɵɵtemplate(1, NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_ng_doc_tab_3_ng_template_1_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(3, NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_ng_doc_tab_3_ng_template_3_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const asset_r3 = ctx.$implicit;
    const label_r4 = i0.ɵɵreference(2);
    const assetContent_r5 = i0.ɵɵreference(4);
    i0.ɵɵproperty("id", asset_r3.title)("label", label_r4)("content", assetContent_r5);
  }
}
function NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ng-doc-tab-group", 10);
    i0.ɵɵpipe(2, "execute");
    i0.ɵɵtemplate(3, NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_ng_doc_tab_3_Template, 5, 3, "ng-doc-tab", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("openedTab", (tmp_5_0 = i0.ɵɵpipeBind2(2, 2, ctx_r1.getOpenedAssetId, ctx_r1.assets)) !== null && tmp_5_0 !== undefined ? tmp_5_0 : ctx_r1.options.defaultTab);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.assets);
  }
}
function NgDocDemoComponent_ng_container_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_0_Template, 2, 1, "ng-container", 7)(1, NgDocDemoComponent_ng_container_0_ng_template_3_ng_container_1_Template, 4, 5, "ng-container", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.assets.length === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.assets.length > 1);
  }
}
function NgDocDemoComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ng-doc-demo-displayer", 5);
    i0.ɵɵtemplate(2, NgDocDemoComponent_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 6)(3, NgDocDemoComponent_ng_container_0_ng_template_3_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const codeContent_r6 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    const demoTemplate_r7 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("codeContent", codeContent_r6)("expanded", !!ctx_r1.options.expanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", demoTemplate_r7);
  }
}
function NgDocDemoComponent_ng_template_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-fullscreen-button", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("route", ctx_r1.options.fullscreenRoute);
  }
}
function NgDocDemoComponent_ng_template_1_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgDocDemoComponent_ng_template_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgDocDemoComponent_ng_template_1_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 16);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r1.demo)("ngComponentOutletInputs", ctx_r1.options.inputs);
  }
}
function NgDocDemoComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgDocDemoComponent_ng_template_1_Conditional_0_Template, 1, 1, "ng-doc-fullscreen-button", 15)(1, NgDocDemoComponent_ng_template_1_Conditional_1_Template, 1, 2, "ng-container");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.options.fullscreenRoute ? 0 : ctx_r1.demo ? 1 : -1);
  }
}
let NgDocDemoComponent = /*#__PURE__*/(() => {
  class NgDocDemoComponent {
    constructor(rootPage) {
      this.rootPage = rootPage;
      this.options = {};
      this.assets = [];
    }
    get classes() {
      return this.options.class ?? '';
    }
    ngOnInit() {
      this.demo = this.getDemo();
      this.assets = this.getAssets();
    }
    getOpenedAssetId(assets) {
      return assets.find(asset => asset.opened)?.title;
    }
    getDemo() {
      if (this.componentName) {
        return this.rootPage.page?.demos && this.rootPage.page.demos[this.componentName];
      }
      return undefined;
    }
    getAssets() {
      if (this.componentName) {
        return ((this.rootPage.demoAssets && this.rootPage.demoAssets[this.componentName]) ?? []).filter(asset => !this.options.tabs?.length || asArray(this.options.tabs).includes(asset.title));
      }
      return [];
    }
    static {
      this.ɵfac = function NgDocDemoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocDemoComponent)(i0.ɵɵdirectiveInject(i1.NgDocRootPage));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocDemoComponent,
        selectors: [["ng-doc-demo"]],
        hostVars: 2,
        hostBindings: function NgDocDemoComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.classes);
          }
        },
        inputs: {
          componentName: "componentName",
          options: "options"
        },
        decls: 3,
        vars: 2,
        consts: [["demoTemplate", ""], ["codeContent", ""], ["label", ""], ["assetContent", ""], [4, "ngIf", "ngIfElse"], [3, "codeContent", "expanded"], [4, "ngTemplateOutlet"], [4, "ngIf"], [3, "html", 4, "ngFor", "ngForOf"], [3, "html"], [3, "openedTab"], [3, "id", "label", "content", 4, "ngFor", "ngForOf"], [3, "id", "label", "content"], [3, "customIcon", 4, "ngIf"], [3, "customIcon"], [3, "route"], [4, "ngComponentOutlet", "ngComponentOutletInputs"]],
        template: function NgDocDemoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NgDocDemoComponent_ng_container_0_Template, 5, 3, "ng-container", 4)(1, NgDocDemoComponent_ng_template_1_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            let tmp_1_0;
            const demoTemplate_r7 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", (tmp_1_0 = ctx.options.container) !== null && tmp_1_0 !== undefined ? tmp_1_0 : true)("ngIfElse", demoTemplate_r7);
          }
        },
        dependencies: [NgIf, NgDocDemoDisplayerComponent, NgTemplateOutlet, NgFor, NgDocCodeComponent, NgDocTabGroupComponent, NgDocTabComponent, NgDocIconComponent, NgDocExecutePipe, NgDocFullscreenButtonComponent, NgComponentOutlet],
        styles: ["[_nghost-%COMP%]{display:block;margin:var(--ng-doc-demo-margin);--ng-doc-tab-group-background: var(--ng-doc-code-background);--ng-doc-tab-group-tabs-background: var(--ng-doc-base-2);--ng-doc-tab-group-border-radius: 0;--ng-doc-tab-group-border: none;--ng-doc-code-border-radius: 0;--ng-doc-code-border: none}[_nghost-%COMP%]   .ng-doc-example[_ngcontent-%COMP%]{padding:calc(var(--ng-doc-base-gutter) * 3)}[_nghost-%COMP%]   ng-doc-icon[_ngcontent-%COMP%]{margin-right:calc(var(--ng-doc-base-gutter) / 2)}[_nghost-%COMP%]   ng-doc-tab-group[_ngcontent-%COMP%]{border-top:1px solid var(--ng-doc-border-color)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocDemoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocDemoComponent };
